import type { MailReward, LegacyBanReview } from "@/lib/api";
import type { AccountTarget } from "./AccountActionDialog";

export function createSubmitLock() {
  let active = false;
  return {
    begin() { if (active) return false; active = true; return true; },
    end() { active = false; },
  };
}

export function captureMail(target: AccountTarget, rewards: MailReward[], subject: string, body: string) {
  return { id: target.id, name: target.displayName, rewards: rewards.map((reward) => ({ ...reward })), subject, body };
}

export function captureBan(target: AccountTarget, kind: "ban" | "revoke", reason: string, hours: string) {
  return { kind, id: target.id, name: target.displayName,
    reason: reason || undefined, hours: hours.trim() ? Number(hours) : undefined };
}

export function captureLegacyBanCorrection(target: AccountTarget, review: LegacyBanReview, selected: string[], reason: string, attemptId: string) {
  if (target.id !== review.playfabId || !reason.trim() || !selected.length || new Set(selected).size !== selected.length
    || selected.some(id => !review.bans.some(b => b.banId === id && !b.corrected && !b.sharedScope))) return null;
  return { id: target.id, correction: { attemptId, source: review.source, sourceTitle: review.sourceTitle,
    reviewSha256: review.reviewSha256, banIds: [...selected], reason: reason.trim() } };
}

export function legacyActionDestination(action: "mail" | "bans", id: string | null) {
  const trimmed = id?.trim();
  return trimmed
    ? `/players/${encodeURIComponent(trimmed)}?action=${action}`
    : `/accounts?selectFor=${action}`;
}

export function selectedAccountDestination(id: string, action: "mail" | "bans" | null) {
  return `/players/${encodeURIComponent(id)}${action ? `?action=${action}` : ""}`;
}
